import { render, staticRenderFns } from "./ItemFormDialog.vue?vue&type=template&id=51685552&"
import script from "./ItemFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ItemFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports